import React from 'react';
import { Shield } from 'lucide-react';
import { Section } from './Shared';
import { WhatsAppIcon, WHATSAPP_URL } from './WhatsAppButton';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-75" data-mp="3gh3sii3dgcgq">
    <div className="glass-panel gold-frame p-9 md:p-14 rounded-sm text-center" data-id="element-76" data-mp="32onj8zjvni7d">
      <Shield className="w-12 h-12 text-brand-gold mx-auto mb-6" data-id="element-77" data-mp="36p6buvtlgsam" />
      <p className="font-seal text-[10px] md:text-xs uppercase tracking-seal text-brand-goldDark mb-4" data-id="element-78" data-mp="36nd5lhmw8a35">
        Garantía de 7 días — sin preguntas
      </p>
      <h2 className="text-2xl md:text-3xl font-display font-bold mb-6 text-brand-purpleDark" data-id="element-79" data-mp="37o6cv1anxdd">
        Abre los tomos. Aplica los protocolos. Úsalos en tu consultorio.
      </h2>
      <p className="text-brand-text/85 mb-6 text-base md:text-lg leading-relaxed" data-id="element-80" data-mp="3qd6u9muba935">
        Si en 7 días no es exactamente lo que esperabas, recibes la devolución
        del 100% del dinero: sin formularios, sin trámites y sin preguntas.
      </p>
      <p className="text-sm text-brand-muted" data-id="element-81" data-mp="2ezurzge79yj3">
        Tasa de devoluciones: menos del 1%.
      </p>
    </div>
  </Section>;
export const Footer = () => <footer className="bg-brand-purpleDark text-brand-surface/80 py-14 border-t border-brand-gold/40" data-id="element-82" data-mp="3gapcti26iifg">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-83" data-mp="3v89cqak7xner">
      <div className="mb-10" data-id="element-84" data-mp="3v5dgcqo0r6sf">
        <h2 className="font-seal text-base md:text-lg uppercase tracking-seal text-brand-goldLight mb-4" data-id="element-85" data-mp="3q83shfga336p">
          Lumen Akasha
        </h2>
        <p className="text-brand-surface/70 text-sm md:text-base max-w-2xl mx-auto leading-relaxed" data-id="element-86" data-mp="817b9zwxjeqw">
          El sistema clínico n.° 1 para terapeutas de Chi Kung en Latinoamérica.
          Porque aplicar Chi Kung con excelencia no debería costarte la
          seguridad ni la energía de tu consultorio.
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-12 text-sm" data-id="element-87" data-mp="qthy6kb6v23d">
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-brand-goldLight transition-colors" data-id="element-88" data-mp="ms6gd0yk3l5q">
          <WhatsAppIcon className="w-4 h-4 shrink-0" data-id="element-89" data-mp="twxsjd47hgaw" />
          WhatsApp
        </a>
        <a href="mailto:soportelumenakasha@gmail.com" className="hover:text-brand-goldLight transition-colors" data-id="element-90" data-mp="yupku88rj4fm">
          soportelumenakasha@gmail.com
        </a>
        <a href="https://instagram.com/lumen.akasha" className="hover:text-brand-goldLight transition-colors" data-id="element-91" data-mp="18kixlckn5plg">
          @lumen.akasha
        </a>
        <a href="https://www.lumenakasha.com" className="hover:text-brand-goldLight transition-colors" data-id="element-92" data-mp="1clckq3q9f0da">
          www.lumenakasha.com
        </a>
      </div>

      <div className="text-xs text-brand-surface/45 space-y-2 border-t border-brand-gold/20 pt-8" data-id="element-93" data-mp="1mjikaeolfuez">
        <p data-id="element-94" data-mp="1rj4xwp8c3cob">
          © Lumen Akasha 2026. Todos los derechos reservados. Prohibida la
          reproducción y la redistribución sin autorización expresa.
        </p>
        <p data-id="element-95" data-mp="3ta8avl5p53c1">Protección de datos personales conforme a la normativa vigente.</p>
      </div>

      <p className="mt-8 text-sm font-display italic text-brand-goldLight/70 max-w-2xl mx-auto" data-id="element-96" data-mp="3tc2w70kvqxgn">
        “El terapeuta que tiene un sistema aplica con confianza. Quien aplica
        con confianza genera resultados. Quien genera resultados, crece.”
      </p>
    </div>
  </footer>;